// Invoice number, take up or Draft when there is no invoice yet.
export const getPolicyTransactionInvoiceLabel = (transaction) => {
	if (!transaction) return '';

	const isTakeUp = transaction.IsTakeUp === true;
	const isPosted = transaction.IsPosted === true;

	if (isTakeUp) {
		return 'Take up';
	}

	if (transaction.IsImported === false && !isPosted) {
		return 'Draft';
	}

	if (transaction.IsImported) {
		return transaction.ImportedInvoiceNumber || '';
	}

	if (transaction.InvoiceNumber != null) {
		return `${transaction.InvoiceNumber}`;
	}

	return '';
};